import React from 'react';

/**
 * KanAIMessageMeta — liten footer under färdiga AI-svar med verktygskörning.
 * Visar t.ex. "KanAI · 3 verktyg använt · 3,1 s".
 *
 * @param {object} props
 * @param {number} [props.toolCount] - antal verktyg som kördes
 * @param {number} [props.elapsedMs] - svarstid i millisekunder
 */
export default function KanAIMessageMeta({ toolCount, elapsedMs }) {
  const parts = ['KanAI'];

  if (typeof toolCount === 'number' && toolCount > 0) {
    parts.push(
      toolCount === 1 ? '1 verktyg använt' : toolCount + ' verktyg använda'
    );
  }
  if (typeof elapsedMs === 'number' && elapsedMs > 0) {
    parts.push((elapsedMs / 1000).toFixed(1).replace('.', ',') + ' s');
  }

  if (parts.length === 1) return null;

  return (
    <div className="kp-kanai-meta">
      {parts.map((p, i) => (
        <React.Fragment key={i}>
          {i > 0 && <span className="kp-kanai-meta__dot" aria-hidden="true" />}
          <span>{p}</span>
        </React.Fragment>
      ))}
    </div>
  );
}
